import { DialogTitle, Typography, useTheme } from "@mui/material";
import { FoodsIconButton } from "@foodpilot/foods";

type Props = {
    title: string;
    onClose: () => void;
};

export const CommentDialogHeader = ({ title, onClose }: Props) => {
    const theme = useTheme();

    return (
        <DialogTitle
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: `solid ${theme.palette.grey[800]} ${theme.spacing(0.1)}`,
                minHeight: `${theme.spacing(8)}`,
                padding: `${theme.spacing(3)}`,
            }}
        >
            <Typography variant="huge-bold">{title}</Typography>
            <FoodsIconButton size="m" icon="close" buttonProps={{ onClick: onClose }} />
        </DialogTitle>
    );
};
